import * as React from "react";
import KPLogs from "./KPLogs";

import {withRouter} from "react-router";
class KPLogsParams extends React.Component{

    render() {
        return (
            <KPLogs
                {...this.props}
                qs = {this.props.location.pathname}
            />
        );
    }
}

export default withRouter(KPLogsParams);